import React, { useContext, useRef, useState, useEffect } from "react";
import { AuthContext } from "./Login";
import Profile from "../components/Profile";
import { motion } from "framer-motion";
import {
  experienceList,
  coreSkills,
  certAwards,
  awards,
  tools,
} from "../helpers/informationData";
import {
  gridContainterVariants,
  gridCubeVariants,
} from "../utilities/customHooks";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase-config";

function About() {
  //Login check
  const { isLogin } = useContext(AuthContext);
  const clientsCollectionRef = collection(db, "Clients");
  const [clientsInfo, setClientsInfo] = useState();

  //Tabs section scrolling
  const experienceRef = useRef(null);
  const coreRef = useRef(null);
  const toolsRef = useRef(null);
  const clientsRef = useRef(null);
  const certificationRef = useRef(null);
  const awardsRef = useRef(null);
  const scrollToExperience = () => {
    if (experienceRef.current) {
      const topPosition =
        experienceRef.current.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: topPosition - 80,
        behavior: "smooth",
      });
    }
  };
  const scrollToCore = () => {
    if (coreRef.current) {
      const topPosition =
        coreRef.current.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: topPosition - 80,
        behavior: "smooth",
      });
    }
  };
  const scrollToTools = () => {
    if (toolsRef.current) {
      const topPosition =
        toolsRef.current.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: topPosition - 80,
        behavior: "smooth",
      });
    }
  };
  const scrollToClients = () => {
    if (clientsRef.current) {
      const topPosition =
        clientsRef.current.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: topPosition - 80,
        behavior: "smooth",
      });
    }
  };
  const scrollToCert = () => {
    if (certificationRef.current) {
      const topPosition =
        certificationRef.current.getBoundingClientRect().top +
        window.pageYOffset;
      window.scrollTo({
        top: topPosition - 80,
        behavior: "smooth",
      });
    }
  };
  const scrollToAwards = () => {
    if (awardsRef.current) {
      const topPosition =
        awardsRef.current.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: topPosition - 80,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    const clientsData = async () => {
      const data = await getDocs(clientsCollectionRef);
      setClientsInfo(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    };
    clientsData();
  }, []);
  return (
    <>
      <Profile />
      <motion.div
        className="box right"
        variants={gridContainterVariants}
        initial="hidden"
        animate="show"
      >
        <div className="tabs">
          <li onClick={scrollToExperience}>Experience</li>
          <li onClick={scrollToCore}>Core Skills</li>
          <li onClick={scrollToTools}>Tools</li>
          <li onClick={scrollToClients}>Clients</li>
          <li onClick={scrollToCert}>Certifications</li>
          <li onClick={scrollToAwards}>Awards</li>
        </div>
        <motion.div
          variants={gridCubeVariants}
          className="section"
          ref={experienceRef}
        >
          <h2>
            👨‍💻 <span>Experience</span>
          </h2>
        </motion.div>
        <div className="experience">
          {experienceList
            ? experienceList.map((experience, index) => {
                return (
                  <motion.div
                    variants={gridCubeVariants}
                    className="list"
                    key={index}
                  >
                    <h4>{experience.companyName}</h4>
                    <p>
                      <span>{experience.designation}</span> |{" "}
                      <span>{experience.duration}</span>
                    </p>
                    <p className="date">
                      <span>{experience.period}</span> |{" "}
                      <span>{experience.location}</span>
                    </p>
                  </motion.div>
                );
              })
            : "No Data"}
        </div>
        <div className="height-50"></div>
        <motion.div
          variants={gridCubeVariants}
          className="section"
          ref={coreRef}
        >
          <h2>
            👨‍🏫 <span>Core Skills</span>
          </h2>
        </motion.div>
        <div className="skills">
          {coreSkills
            ? coreSkills.map((skill, index) => {
                return (
                  <motion.div variants={gridCubeVariants} className="skill">
                    {skill}
                  </motion.div>
                );
              })
            : "No Data"}
        </div>
        <div className="height-50"></div>
        <motion.div
          variants={gridCubeVariants}
          className="section"
          ref={toolsRef}
        >
          <h2>
            🤹 <span>Tools</span>
          </h2>
        </motion.div>
        <div className="skills">
          {tools
            ? tools.map((tool, index) => {
                return (
                  <motion.div variants={gridCubeVariants} className="skill">
                    <img src={tool.icon} />
                    {tool.name}
                  </motion.div>
                );
              })
            : "No Data"}
        </div>
        <div className="height-50"></div>
        <motion.div
          variants={gridCubeVariants}
          className="section"
          ref={clientsRef}
        >
          <h2>
            🤹 <span>Clients</span>
          </h2>
        </motion.div>
        <motion.div variants={gridCubeVariants} className="clients">
          <p>
            I’ve had the opportunity to work with clients across 8 different
            countries, not just remotely but by being present in some of those
            countries. This hands-on experience has given me a deep
            understanding of global UX needs, cultural diversity, and how to
            adapt design solutions to fit local markets. By working on-site,
            I’ve been able to engage directly with users and stakeholders,
            ensuring that the designs are not only innovative but also aligned
            with regional preferences and business goals.
          </p>

          {clientsInfo
            ? clientsInfo.map((clients) => {
                const sortedClient = clients.client.sort((a, b) =>
                  a.localeCompare(b)
                );
                return (
                  <>
                    <div className="client" key={clients.id}>
                      {sortedClient.map((sector, spanIndex) => {
                        return <span className={`chip-${spanIndex}`} key={spanIndex}>{sector}</span>;
                      })}
                    </div>
                  </>
                );
              })
            : ""}
        </motion.div>
        <div className="height-50"></div>
        <motion.div
          variants={gridCubeVariants}
          className="section"
          ref={certificationRef}
        >
          <h2>
            🏅 <span>Certifications</span>
          </h2>
        </motion.div>
        <div className="experience">
          {certAwards
            ? certAwards.map((award, index) => {
                return (
                  <motion.div
                    variants={gridCubeVariants}
                    className="list"
                    key={index}
                  >
                    <h4>{award.name}</h4>
                    <div className="club">
                      <img src={award.logo} />
                      <p>{award.organization}</p>
                    </div>
                    <p className="date">
                      <span>{award.receivedYear}</span> &nbsp;
                      <a
                        href={award.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View
                      </a>
                    </p>
                  </motion.div>
                );
              })
            : "No Data"}
        </div>
        <div className="height-50"></div>
        <motion.div
          variants={gridCubeVariants}
          className="section"
          ref={awardsRef}
        >
          <h2>
            🏅 <span>Awards</span>
          </h2>
        </motion.div>
        <div className="experience">
          {awards
            ? awards.map((award, index) => {
                return (
                  <motion.div
                    variants={gridCubeVariants}
                    className="list"
                    key={index}
                  >
                    <h4>{award.name}</h4>
                    <p>{award.organization}</p>
                    <p className="date">
                      <span>{award.receivedYear}</span> &nbsp;
                      <a
                        href={award.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View
                      </a>
                    </p>
                  </motion.div>
                );
              })
            : "No Data"}
        </div>
      </motion.div>
    </>
  );
}

export default About;
